import Box from '@mui/material/Box';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';

type AddButtonProps = {
  text: string;
  tooltipText: string;
  onAdd: () => void;
};

export const AddButton = ({ text, onAdd }: AddButtonProps) => {
  return (
    <Box
      component="span"
      data-test="add-includes-group"
      sx={{
        pt: 1,
      }}
    >
      <Button variant="text" color="primary" onClick={onAdd}>
        {text}
      </Button>
    </Box>
  );
};
